export * from "/codebuild/output/src3707907817/src/git-codecommit.eu-west-2.amazonaws.com/v1/repos/vl-app/vl-common/wrapped-antd/index.ts"